import { useCallback } from 'react';
import { useFeConfig } from '@meiqia/component';

import { useSelector, useDispatch } from '../../../react-redux';
import { mergeNavSetting } from '../../../reducers/nav-setting-BESPOKE';

const useNavSetting = () => {
  const { getFeConfig: getNavSettingApi, updateFeConfig: updateNavSettingApi } = useFeConfig({
    key: 'nav_setting'
  });
  const navSetting = useSelector(state => state.getIn(['navSetting']));
  const dispatch = useDispatch();

  const handleUpdateNavSetting = useCallback(data => {
    const stringData = JSON.stringify(data);
    return updateNavSettingApi(stringData).then(res => {
      if (res?.data) {
        dispatch(mergeNavSetting(data));
      }
      return res;
    });
  }, []);

  const handleGetNavSetting = useCallback(
    () =>
      getNavSettingApi().then(res => {
        if (res?.data?.nav_setting) {
          try {
            const setting = JSON.parse(res.data.nav_setting);
            dispatch(mergeNavSetting(setting));
            localStorage.setItem('navSettingConfig', JSON.stringify(setting));
          } catch (e) {
            console.log(e);
            // ignore
          }
        }
      }),
    []
  );

  return {
    navSetting,
    handleGetNavSetting,
    handleUpdateNavSetting
  };
};

export default useNavSetting;
